import type { ReactNode } from 'react'

import styles from './statusPill.module.scss'

export type StatusPillTone = 'active' | 'done' | 'muted'

type StatusPillProps = {
  tone: StatusPillTone
  children: ReactNode
}

export const StatusPill = ({ tone, children }: StatusPillProps) => (
  <span className={`${styles.pill} ${styles[tone]}`}>{children}</span>
)
